const NEXTGEN_HOMEPAGE = "nextgen home page";
const NEXTGEN_SEARCHPAGE = "nextgen search page";
const NEXTGEN_CUSTOISATIONPAGE = "nextgen customisation page";
const NEXTGEN_SEARCH_CUSTOMISATIONPAGE = "nextgen search customisation page";
const NEXTGEN_NON_CUSTOMISATIONPAGE = "nextgen non customisation page";
const NEXTGEN_SEARCH_NON_CUSTOMISATIONPAGE =
  "nextgen search non customisation page";
const NEXTGEN_MENUPAGE = "nextgen menu page";
const NEXTGEN_EDVPAGE = "nextgen edv page";
const NEXTGEN_LINKREWRITE_HOME = 'home';
const NEXTGEN_LINKREWRITE_HOME_GUEST = 'home-guest';
const NEXTGEN_LINKREWRITE_MENU = 'menu';
const NEXTGEN_LINKREWRITE_MENUV1 = 'menu-v1';
const NEXTGEN_LINKREWRITE_MENUV2 = 'menu-v2';
const NEXTGEN_LINKREWRITE_DELETE_ACCOUNT = 'delete-account';
const NEXTGEN_LINKREWRITE_EDV = 'edv';

export default {
  NEXTGEN_HOMEPAGE,
  NEXTGEN_SEARCHPAGE,
  NEXTGEN_CUSTOISATIONPAGE,
  NEXTGEN_SEARCH_CUSTOMISATIONPAGE,
  NEXTGEN_NON_CUSTOMISATIONPAGE,
  NEXTGEN_SEARCH_NON_CUSTOMISATIONPAGE,
  NEXTGEN_MENUPAGE,
  NEXTGEN_EDVPAGE,
  NEXTGEN_LINKREWRITE_HOME,
  NEXTGEN_LINKREWRITE_HOME_GUEST,
  NEXTGEN_LINKREWRITE_MENU,
  NEXTGEN_LINKREWRITE_MENUV1,
  NEXTGEN_LINKREWRITE_MENUV2,
  NEXTGEN_LINKREWRITE_DELETE_ACCOUNT,
  NEXTGEN_LINKREWRITE_EDV
};
